import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { DateTime } from 'luxon'
import React from 'react'

const useStyles = makeStyles(theme => ({
  expired: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontSize: '.75em',
    textDecoration: 'line-through',
  },
  pending: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontSize: '.75em',
  },
  rectangle: {
    borderRadius: '.25em',
    letterSpacing: '0.063em',
    padding: '.25rem .7rem',
    textTransform: 'uppercase',
  },
  selected: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    fontSize: '1em',
    fontWeight: 900,
  },
}))
type ReleasePhaseTagProps = {
  endsAt: DateTime
  selected: boolean
  text: string
}

const ReleasePhaseTag = ({ text, selected, endsAt }: ReleasePhaseTagProps) => {
  const classes = useStyles()
  const isExpired = endsAt < DateTime.utc()

  // todo: enable selected styles for expired and pending phases

  return (
    <div
      className={clsx(classes.rectangle, {
        [classes.selected]: selected,
        [classes.expired]: isExpired,
        [classes.pending]: !isExpired && !selected,
      })}
    >
      {text}
    </div>
  )
}

export default ReleasePhaseTag
